import React from 'react';
import '../styles/App.css';
import '../styles/crud_pssd.css';
import Sidebar from '../components/sidemenu/sidebar';
import {ip_back , api_key} from '../constants/appConstants';



const handleFormSubmit = async (e) => {
    e.preventDefault();
    const storedUser = JSON.parse(localStorage.getItem("user"));
    const form = e.target;
    const contrasena = form.elements["contrasena_actual"].value;
    const nueva_contrasena = form.elements["nueva_contrasena"].value;
    const confirmacion_contraseña = form.elements["confirmacion_contrasena"].value;
    var API_URL = '';
    if (nueva_contrasena===confirmacion_contraseña) {
      API_URL = ip_back + '/api/usuarios/cambio_contrasena';
      try {
        const response = await fetch(API_URL, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': api_key,
          },
          body: JSON.stringify({ 'usuario' : storedUser, 'contrasena' : contrasena, 'nueva_contrasena' : nueva_contrasena, 'editor' : storedUser}),
        });
  
        if (response.ok) {
            alert('Cambio de contraseña exitoso');
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            window.location.href = "/inicio";
        } else {
          console.error('Error al guardar cambios:', response.statusText);
        }
      } catch (error) {
        console.error('Error al hacer la solicitud:', error);
      }
    }else{
        alert('Las nuevas contraseñas no coinciden');
    }  
  };

const CambioContrasena = () => {
  return (
    <div>
        <Sidebar/>
        <div>
            <h3 className="title"> Cambio Contraseña</h3>
        </div>
        <div>
            <form onSubmit={handleFormSubmit} className='form_crud_pssd'>
              <input
                type="password"
                name="contrasena_actual"
                placeholder="Contraseña Actual"
                required
              />
              <input
                type="password"
                name="nueva_contrasena"
                placeholder="Nueva Contraseña"
                required
              />
              <input
                type="password"
                name="confirmacion_contrasena"
                placeholder="Confirmación Contraseña"
                required
              />
              <button type="submit" className='submit'>Cambiar Contraseña</button>
            </form>
          </div>
    </div>
  );


};

export default CambioContrasena;